var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAffirm = function SvgAffirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.483,
    y: 1.25,
    width: 25.5,
    height: 25.5,
    rx: 12.75,
    fill: "#494AF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.483,
    y: 1.25,
    width: 25.5,
    height: 25.5,
    rx: 12.75,
    stroke: "#F5F5F5",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.608 19.51a6.383 6.383 0 0 1-1.05-3.515 6.434 6.434 0 0 1 6.426-6.426 6.434 6.434 0 0 1 6.427 6.426 6.393 6.393 0 0 1-1.05 3.516h1.799a7.945 7.945 0 0 0 .816-3.516c0-4.406-3.585-7.99-7.99-7.99-4.407 0-7.991 3.584-7.991 7.99 0 1.261.294 2.454.816 3.516h1.797Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.092 12.198c-1.17 0-2.517.552-3.248 1.135l.667 1.405c.586-.536 1.535-.995 2.39-.995.812 0 1.26.272 1.26.82 0 .368-.298.576-.86.627-2.108.194-3.746.852-3.746 2.47 0 1.284.925 2.06 2.447 2.06 1.019 0 1.819-.567 2.25-1.314v1.104h1.899v-4.626c0-1.91-1.328-2.686-3.059-2.686Zm-.554 6.038c-.615 0-.952-.263-.952-.695 0-.902 1.101-1.12 2.536-1.12 0 .944-.632 1.815-1.584 1.815Z",
    fill: "#fff"
  })));
};
export default SvgAffirm;